import React from 'react'
import { Cell, Grid } from 'react-mdl'
import './style.css'

import ItemHelper from "APP/lib/utils";

// Components.
import Item from '../item'
import Calculator from 'APP/lib/bonus-calculator';
import Merc from 'APP/lib/merc-map';

export default class MercItems extends React.Component {

    state = {
        items: null,
        bonuses: null,
        type: null,
        name: null,
        level: null,
        attributes: null
    }

    constructor(props) {
        super(props);

        var bonuses = {
            ias: 0,
            fcr: 0,
            ds: 0,
            cb: 0,
            fhr: 0,
            frw: 0,
            dr: 0,
            mf: 0,
            gf: 0,
            ll: 0,
            ml: 0
        };
        var setItems = {};

        if (props.data.items.length > 0) {
            props.data.items.map(function (item) {
                let setBonuses = [];
                let setPartialBonuses = [];
                if (item.set_id !== undefined) {
                    if (props.data.set_bonuses[item.set_id] !== undefined) {
                        setBonuses = props.data.set_bonuses[item.set_id];
                    }
                    if (item.main_set_partial_bonuses !== undefined) {
                        setPartialBonuses = item.main_set_partial_bonuses;
                    }
                }
                item.setBonuses = setBonuses;
                item.setPartialBonuses = setPartialBonuses;
                if (item.magic_attributes !== undefined) {
                    Calculator.calculate(bonuses, item.magic_attributes);
                }
                Calculator.calculate(bonuses, setPartialBonuses);
                ItemHelper.handleSetItem(item, setItems);
                return true;
            });
            props.data.items.forEach((item) => {
                if (item.set_id !== undefined) {
                    item.setInfo = setItems[item.set_id];
                }
            });
        }
        if (props.data.set_bonuses !== undefined) {
            for (const [setId, setBonuses] of Object.entries(props.data.set_bonuses)) { // eslint-disable-line no-unused-vars
                Calculator.calculate(bonuses, setBonuses);
            }
        }
        // Get the merc data from the merc mapper.
        var data = Merc.data[props.type]

        // Get merc name. e.g. Azreal and so on.
        var mercName = null
        if (Merc[data.type].hasOwnProperty(props.name)) {
            mercName = Merc[data.type][props.name]
        }

        this.state = {
            items: props.data.items,
            level: props.level,
            bonuses: bonuses,
            name: mercName,
            data: data,
        };
    }

    render() {
        return (
            <Grid className="merc-inner">
                <Cell className="merc-bonuses" col={6} tablet={12} phone={12}>
                    <h3 className="underlined">Key bonuses</h3>
                    <ul>
                        {(this.state.bonuses.fhr > 0) ?
                            <li className="fhr">Faster hit recovery: <span className="bonus-value">{this.state.bonuses.fhr}%</span></li>
                            :
                            null
                        }
                        {(this.state.bonuses.ias > 0) ?
                            <li className="ias">Increased attack speed: <span className="bonus-value">{this.state.bonuses.ias}%</span></li>
                            :
                            null
                        }
                        {(this.state.bonuses.frw > 0) ?
                            <li className="frw">Faster run/walk: <span className="bonus-value">{this.state.bonuses.frw}%</span></li>
                            :
                            null
                        }
                        {(this.state.bonuses.dr > 0) ?
                            <li className="dr">Damage reduction: <span className="bonus-value">{this.state.bonuses.dr}%</span></li>
                            :
                            null
                        }
                        {(this.state.bonuses.mf > 0) ?
                            <li className="mf">Better chance of getting magic items: <span className="bonus-value">{this.state.bonuses.mf}%</span></li>
                            :
                            null
                        }
                        {(this.state.bonuses.gf > 0) ?
                            <li className="gf">Extra Gold from Monsters: <span className="bonus-value">{this.state.bonuses.gf}%</span></li>
                            :
                            null
                        }
                        {(this.state.bonuses.cb > 0) ?
                            <li className="cb">Crushing blow: <span className="bonus-value">{this.state.bonuses.cb}%</span></li>
                            :
                            null
                        }
                        {(this.state.bonuses.ds > 0) ?
                            <li className="ds">Deadly strike: <span className="bonus-value">{this.state.bonuses.ds}%</span></li>
                            :
                            null
                        }
                        {(this.state.bonuses.ll > 0) ?
                            <li className="ll">Life Stolen Per Hit: <span className="bonus-value">{this.state.bonuses.ll}%</span></li>
                            :
                            null
                        }
                    </ul>
                </Cell>
                <Cell className="merc-items" col={6} tablet={12} phone={12}>
                    {this.state.name !== null && (
                        <h1 className="merc-text merc-name">{this.state.name} ({this.state.level})</h1>
                    )}
                    <h3 className="merc-text merc-type">{this.state.data.name}</h3>

                    {this.state.data.attributes !== undefined && (
                        <p className="merc-text merc-attributes">({this.state.data.attributes})</p>
                    )}
                    {this.state.data.aura !== undefined && (
                        <h3 className="merc-text merc-aura">{this.state.data.aura}</h3>
                    )}

                    <div className="equipped-items">
                        {this.state.items.map((item) =>
                            <Item key={(item.id)} data={item} />
                        )}
                        <div className="item-backdrop location-1"></div>
                        <div className="item-backdrop location-2"></div>
                        <div className="item-backdrop location-3"></div>
                        <div className="item-backdrop location-4"></div>
                        <div className="item-backdrop location-8"></div>
                        <div className="item-backdrop location-9"></div>
                        <div className="item-backdrop location-10"></div>
                    </div>
                </Cell>
            </Grid>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/merc/index.js